import { Request } from '@/utils';

class Login extends Request {
	loginByTicket(ticket: string) {
		return this.post<string | null>({
			url: `/api/FormLogin/LoginByTicket?ticket=${encodeURIComponent(ticket)}`,
		});
	}

	// 根据企微 OAuth code 登录
	loginByCode(code: string) {
		return this.post<string | null>({
			url: `/mobile/loginByCode?code=${code}`,
		});
	}

	// 获取企业微信 OAuth 授权跳转地址
	getWxOAuthUrl(state?: string) {
		return this.get<string>({
			url: '/mobile/wx/oauthUrl',
			data: state ? { state } : undefined,
		});
	}

	// 根据 empCode 登录
	loginByEmpCode(empCode: string) {
		return this.post<string | null>({
			url: `/mobile/loginByEmpCode?empCode=${empCode}`,
		});
	}

	// 发送手机号登录验证码
	sendLoginSmsCode(phone: string) {
		return this.post<null>({
			url: `/mobile/sendLoginSmsCode?phone=${phone}`,
		});
	}

	// 根据手机号验证码登录
	loginByPhone(phone: string, verifyCode: string) {
		return this.post<string | null>({
			url: `/mobile/loginByPhone?phone=${phone}&verifyCode=${verifyCode}`,
		});
	}
}

export const LoginApi = new Login();
